export default {
    id: 'green',
    colors: ['#0E752E', '#A5ED8E'],
};
